import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NoPreloading, PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { environment } from 'src/environments/environment';

import { RecuperarComponent } from './recuperar/recuperar.component';
// import { DarseAltaComponent } from './darse-alta/darse-alta.component';
// import { ExtractosEdicionComponent } from './modules/pages/accounting/extractos-edicion/extractos-edicion.component';
// import { MenuComponent } from './modules/pages/home/menu/menu.component';
// import { ErpComponent } from './modules/pages/erp/erp/erp.component';

const appRoutes: Routes=[
  {
    path: '',
    redirectTo: environment.version+'index',
    pathMatch: 'full'
  },
  /* {
    path: environment.version+'login',
    loadChildren: () => import('./modules/pages/login/login.module').then(m => m.LoginModule)
  }, */
  {
    path: environment.version+'index',
    loadChildren: () => import('./modules/pages/index/index.module').then(m => m.IndexModule)
  },
 /*  {
    path: environment.version+'web',
    loadChildren: () => import('../web/web/web.module').then(m => m.WebModule)
  }, */
  {
    path: environment.version+'',
    loadChildren: () => import('./modules/modules.module').then(m => m.ModulesModule)
  },

  {path: environment.version+'recover',component:RecuperarComponent},
  // {path: environment.version+'registro',component: DarseAltaComponent},


  // {path: environment.version+'erp', component: ErpComponent},
  // {path: environment.version+'home', component:MenuComponent},
  // {path: environment.version+'validation/edit/:IdProceso', component: ExtractosEdicionComponent},

  // { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(appRoutes, {
      useHash:true,
      initialNavigation:'enabledBlocking',
      // preloadingStrategy: PreloadAllModules
      preloadingStrategy: NoPreloading
    }),
    CommonModule
  ],
  exports: [RouterModule],

})
export class AppRoutingModule { }
